import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import styles from './mobile-fullscreen-panel.module.css';

// The one mobile presentation for every overlay panel in the app (widget
// deep-dive, Settings, Notifications): a plain full-viewport surface with no
// slide-in animation, a header with a close X, and an optional non-scrolling
// row (tabs, filters) between the header and the scrollable body.
export default function MobileFullscreenPanel({
  header,
  subHeader,
  onClose,
  headerDivider = true,
  headerClassName,
  closeButtonClassName = 'btn btn-sm text-muted',
  children,
}: React.PropsWithChildren<{
  header: React.ReactNode;
  subHeader?: React.ReactNode;
  onClose: () => void;
  /** Line separating the header row from the body below. Default true. */
  headerDivider?: boolean;
  /** Extra className appended to the header row (e.g. to match a specific sibling row's padding/height exactly). */
  headerClassName?: string;
  /** Default 'btn btn-sm text-muted'. */
  closeButtonClassName?: string;
}>) {
  return (
    <div className={styles.overlay}>
      <div
        className={`${styles.header}${headerDivider ? '' : ` ${styles.headerNoDivider}`}${headerClassName ? ` ${headerClassName}` : ''}`}
      >
        <div className={styles.headerContent}>{header}</div>
        <button type={'button'} className={closeButtonClassName} onClick={onClose} title={'Close'}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
      {subHeader && <div className={styles.subHeader}>{subHeader}</div>}
      <div className={styles.body}>{children}</div>
    </div>
  );
}
